import UserPermissionsDomainActionTypes from './action-types';

export const userPermissionsDomainAction = (payload) => ({
  type: UserPermissionsDomainActionTypes.USER_PERMISSIONS_DOMAIN,
  payload,
});
